import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Styles from './styles.js';


function SampleNextArrow(props) {
  const { onClick, iconColor } = props;
  return (
    <div className={' slick-arrow right-arrow'} onClick={onClick}>
      <svg
        viewBox="0 0 24 24"
        fill={iconColor}
        width="28"
        height="28"
        data-ux="Icon"
        data-edit-interactive="true"
        className="x-el x-el-svg  ">
        <path
          fillRule="evenodd"
          d="M7.236 4.195a.773.773 0 0 1 
          1.06.031l7.743 7.883-7.742 7.42a.773.773 
          0 0 1-1.06 0 .697.697 0 0 1
           0-1.017l6.712-6.433-6.745-6.868a.697.697 0 0 1 .032-1.016"></path>
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick, iconColor } = props;
  return (
    <div className={' slick-arrow left-arrow'} style={{}} onClick={onClick}>
      <svg
        viewBox="0 0 24 24"
        fill={iconColor}
        width="28"
        height="28"
        data-ux="Icon"
        data-edit-interactive="true"
        className="x-el x-el-svg  ">
        <path
          fillRule="evenodd"
          d="M15.804 19.544a.774.774 0 0
           1-1.061-.03L7 11.63l7.742-7.42a.773.773
            0 0 1 1.061 0 .697.697 0 0 1 0 1.017L9.09
             11.66l6.745 6.867a.698.698 0 0 1-.031 1.016"></path>
      </svg>
    </div>
  );
}

const TestimonialSlider = ({ bg, iconColor, testimonal }) => {
  var settings = {
    className: 'slider testimonialSlider variable-width',
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    variableWidth: true,
    nextArrow: <SampleNextArrow iconColor={iconColor} />,
    prevArrow: <SamplePrevArrow iconColor={iconColor} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          arrows: true,
        },
      },
      {
        breakpoint: 840,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  var settingsWhite = {
    className: 'slider testimonialSlider slider-white variable-width',
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    variableWidth: true,
    nextArrow: <SampleNextArrow iconColor={iconColor} />,
    prevArrow: <SamplePrevArrow iconColor={iconColor} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          arrows: true,
        },
      },
      {
        breakpoint: 840,

        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          dots: false,

          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      {bg == 'true' ? (
        <div className="container mx-auto  pb-5">
          <Slider {...settings}>
            {testimonal.map((item, index) => (
              <div className="lg:my-4 " key={index}>
                <div
                  className="  card lg:mb-5 py-4 border-0    flex flex-col
                      justify-center items-center rounded-0 text-center 
                      mx-2 md:mx-4 ">
                  <img src={item.testimonalImg} alt="..." className="rounded-circle " />
                  <div className=" ">
                    <div className="flex pt-4 pb-2 justify-center">
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="28"
                        height="28"
                        data-ux="Icon"
                        data-aid="RECOMMENDATION_ICON_RENDERED"
                        className="me-2 x-el x-el-svg     ">
                        <path
                          fill="#F277A7"
                          fillRule="evenodd"
                          d="M6 18l-4 2 2-4V6a2 2 0 0 1 2-2h14a2 2 
                        0 0 1 2 2v10a2 2 0 0 1-2 2H6zm7-4.367L15.472 
                        15 15 12.106l2-2.05-2.764-.423L13 7l-1.236 
                        2.633L9 10.056l2 2.05L10.528 15 13 13.633z"></path>
                      </svg>

                      <p
                        className="ms-2 abs fs-16-18"
                        style={{
                          fontFamily: 'josefin Sans',
                        }}>
                        Recommends
                      </p>
                    </div>
                    <p
                      className=" lg:pt-1 fs-18-23  px-3"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                        height: '90px',
                        overflow: 'hidden',
                      }}>
                      {item.testimonalDesc}
                    </p>
                    {item.testimonalBtn == true ? (
                      <a
                        href={item.testimonalLink}
                        target="_blank"
                        rel="noreferrer"
                        className="  text-decoration-none fs-responsive-18 md:pt-1 lg:pt-0 link-warning "
                        style={{
                          fontFamily: 'josefin Sans',

                          color: '#946F00',
                        }}>
                        Read full review
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width="1em"
                          height="1em"
                          data-ux="Icon"
                          data-aid="chevronRight"
                          className="x-el x-el-svg   ">
                          <path
                            fillRule="evenodd"
                            d="M7.236 4.195a.773.773 0 0 1 1.06.031l7.743 
            7.883-7.742 7.42a.773.773 0 0 1-1.06 0 .697.697
             0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
              0 0 1 .032-1.016"></path>
                        </svg>
                      </a>
                    ) : (
                      <div className="testi-h"></div>
                    )}
                  </div>
                  <div className="flex pt-3 pb-4 justify-center px-3">
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      width="28"
                      height="28"
                      data-ux="Icon"
                      className=" me-3 x-el x-el-svg   "
                      style={{
                        fontFamily: 'josefin Sans',
                        fontSize: '18px',
                        color: '#4267b4',
                      }}>
                      <path
                        fillRule="evenodd"
                        d="M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0
             5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.91h2.54V9.845c0-2.522
              1.492-3.915 3.777-3.915 1.094 0 2.238.197 
              2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 
              1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755
               8.437-4.917 8.437-9.939z"></path>
                    </svg>
                    <p
                      className=" ms-1 fs-responsive-14 font-bold pt-1  "
                      style={{
                        fontFamily: 'josefin Sans',
                        fontSize: '14px',
                        color: '#595959',
                      }}>
                      {item.testimonalDate}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <div className="container mx-auto pt-6 px-3 pb-12">
          <Slider {...settingsWhite}>
            {testimonal.map((item, index) => (
              //               <div className="" key={index}>
              //                 <div
              //                   className="   card my-5 card-shadow   py-4 border-0   d-flex flex-column
              //  justify-content-center align-items-center rounded-0 text-center
              //  mx-2 mx-md-4 ">
              //                   <img src={item.testimonalImg} alt="..." className="rounded-circle " />
              //                   <div className=" ">
              //                     <div className="d-flex pt-4 pb-2 justify-content-center">
              //                       <svg
              //                         viewBox="0 0 24 24"
              //                         fill="currentColor"
              //                         width="28"
              //                         height="28"
              //                         data-ux="Icon"
              //                         data-aid="RECOMMENDATION_ICON_RENDERED"
              //                         className="me-2 x-el x-el-svg     ">
              //                         <path
              //                           fill="#F277A7"
              //                           fillRule="evenodd"
              //                           d="M6 18l-4 2 2-4V6a2 2 0 0 1 2-2h14a2 2
              //           0 0 1 2 2v10a2 2 0 0 1-2 2H6zm7-4.367L15.472
              //           15 15 12.106l2-2.05-2.764-.423L13 7l-1.236
              //           2.633L9 10.056l2 2.05L10.528 15 13 13.633z"></path>
              //                       </svg>

              //                       <p
              //                         className="ms-2 fs-16-18"
              //                         style={{
              //                           fontFamily: 'josefin Sans',

              //                           color: '#5e5e5e',
              //                         }}>
              //                         Recommends
              //                       </p>
              //                     </div>
              //                     <p
              //                       className="pb-5 pt-lg-1 fs-18-23"
              //                       style={{
              //                         fontFamily: 'josefin Sans',

              //                         color: '#1b1b1b',
              //                       }}>
              //                       {item.testimonalDesc}
              //                     </p>
              //                     {item.testimonalBtn == true ? (
              //                       <a
              //                         href={item.testimonalLink}
              //                         target="_blank"
              //                         rel="noreferrer"
              //                         className="  text-decoration-none fs-responsive-18 pt-md-1 pt-lg-0 link-warning "
              //                         style={{
              //                           fontFamily: 'josefin Sans',

              //                           color: '#946F00',
              //                         }}>
              //                         Read full review
              //                         <svg
              //                           viewBox="0 0 24 24"
              //                           fill="currentColor"
              //                           width="1em"
              //                           height="1em"
              //                           data-ux="Icon"
              //                           data-aid="chevronRight"
              //                           className="x-el x-el-svg   ">
              //                           <path
              //                             fillRule="evenodd"
              //                             d="M7.236 4.195a.773.773 0 0 1 1.06.031l7.743
              //             7.883-7.742 7.42a.773.773 0 0 1-1.06 0 .697.697
              //              0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
              //               0 0 1 .032-1.016"></path>
              //                         </svg>
              //                       </a>
              //                     ) : (
              //                       <div className="p-0-5">
              //                         <div className="mt-3  pb-4 pb-md-4 pb-lg-4 pb-xl-4 mt-xl-1">
              //                           <br className="" />
              //                         </div>
              //                       </div>
              //                     )}
              //                   </div>
              //                   <div className="d-flex pt-3 justify-content-center ">
              //                     <svg
              //                       viewBox="0 0 24 24"
              //                       fill="currentColor"
              //                       width="28"
              //                       height="28"
              //                       data-ux="Icon"
              //                       className=" me-3 x-el x-el-svg   "
              //                       style={{
              //                         fontFamily: 'josefin Sans',
              //                         fontSize: '18px',
              //                         color: '#4267b4',
              //                       }}>
              //                       <path
              //                         fillRule="evenodd"
              //                         d="M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0
              //          5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.91h2.54V9.845c0-2.522
              //           1.492-3.915 3.777-3.915 1.094 0 2.238.197
              //           2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63
              //           1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755
              //            8.437-4.917 8.437-9.939z"></path>
              //                     </svg>
              //                     <p
              //                       className=" ms-1 fs-responsive-14 fw-bold pt-1  "
              //                       style={{
              //                         fontFamily: 'josefin Sans',
              //                         fontSize: '14px',
              //                         color: '#595959',
              //                       }}>
              //                       {item.testimonalDate}
              //                     </p>
              //                   </div>
              //                 </div>
              //               </div>
              <div className="my-6 " key={index}>
                <div
                  className=" 
                  bg-white
                    mx-6 mb-12 py-6
                   card card-shadow  border-0    flex flex-col
                    justify-center items-center rounded-0 text-center 
                    ">
                  <img src={item.testimonalImg} alt="..." className="rounded-full testimonialImg " />
                  <div className=" ">
                    <div className="flex pt-4 pb-2 justify-center">
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="28"
                        height="28"
                        data-ux="Icon"
                        data-aid="RECOMMENDATION_ICON_RENDERED"
                        className="me-2 x-el x-el-svg     ">
                        <path
                          fill="#F277A7"
                          fillRule="evenodd"
                          d="M6 18l-4 2 2-4V6a2 2 0 0 1 2-2h14a2 2 
                          0 0 1 2 2v10a2 2 0 0 1-2 2H6zm7-4.367L15.472 
                          15 15 12.106l2-2.05-2.764-.423L13 7l-1.236 
                          2.633L9 10.056l2 2.05L10.528 15 13 13.633z"></path>
                      </svg>

                      <p
                        className="ml-2 abs fs-16-18"
                        style={{
                          fontFamily: 'josefin Sans',
                        }}>
                        Recommends
                      </p>
                    </div>
                    <p
                      className=" lg:pt-1 fs-18-23  px-3"
                      style={{
                        fontFamily: 'josefin Sans',
                        color: '#1b1b1b',
                        height: '90px',
                        overflow: 'hidden',
                      }}>
                      {item.testimonalDesc}
                    </p>
                    {item.testimonalBtn == true ? (
                      <a
                        href={item.testimonalLink}
                        target="_blank"
                        rel="noreferrer"
                        className="  text-decoration-none fs-responsive-18 md:pt-1 lg:pt-0 link-warning "
                        style={{
                          fontFamily: 'josefin Sans',

                          color: '#946F00',
                        }}>
                        Read full review
                        <svg
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          width="1em"
                          height="1em"
                          data-ux="Icon"
                          data-aid="chevronRight"
                          className="x-el x-el-svg   ">
                          <path
                            fillRule="evenodd"
                            d="M7.236 4.195a.773.773 0 0 1 1.06.031l7.743 
                            7.883-7.742 7.42a.773.773 0 0 1-1.06 0 .697.697
                            0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                            0 0 1 .032-1.016"></path>
                        </svg>
                      </a>
                    ) : (
                      <div className="testi-h-w"></div>
                    )}
                  </div>
                  <div className="flex pt-4 h-name justify-center items-center  px-4">
                    <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      width="28"
                      height="28"
                      data-ux="Icon"
                      className=" me-3 x-el x-el-svg   "
                      style={{
                        fontFamily: 'josefin Sans',
                        fontSize: '18px',
                        color: '#4267b4',
                      }}>
                      <path
                        fillRule="evenodd"
                        d="M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0
                        5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.91h2.54V9.845c0-2.522
                        1.492-3.915 3.777-3.915 1.094 0 2.238.197 
                          2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 
                          1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755
                        8.437-4.917 8.437-9.939z"></path>
                    </svg>
                    <p
                      className=" ms-1 fs-responsive-14 font-bold pt-1  "
                      style={{
                        fontFamily: 'josefin Sans',
                        fontSize: '14px',
                        color: '#595959',
                      }}>
                      {item.testimonalDate}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
      <Styles/>
    </>
  );
};
export default TestimonialSlider;
